module.exports = __webpack_public_path__ + "img/t7-1.3e850464.png";